import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"

type VideoDurationStepProps = {
  selected: 4 | 8 | 12
  onSelect: (duration: 4 | 8 | 12) => void
}

const DURATION_OPTIONS = [
  { value: 4 as const, labelKey: "4s", descKey: "4sDesc" },
  { value: 8 as const, labelKey: "8s", descKey: "8sDesc" },
  { value: 12 as const, labelKey: "12s", descKey: "12sDesc" },
]

export function VideoDurationStep({ selected, onSelect }: VideoDurationStepProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "studioAi.video.duration" })

  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <div>
        <h2 className="text-lg font-semibold">{t("title")}</h2>
        <p className="text-muted-foreground text-sm">{t("description")}</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        {DURATION_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={cn(
              "flex flex-col items-start gap-2 rounded-xl border-2 p-6 text-left transition-[border-color,background-color,box-shadow]",
              "hover:border-primary/50 hover:shadow-sm",
              "focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none",
              selected === option.value ? "border-primary bg-primary/5 shadow-sm" : "border-border"
            )}
            onClick={() => onSelect(option.value)}
          >
            <p className="text-lg font-bold">{t(option.labelKey)}</p>
            <p className="text-muted-foreground text-sm">{t(option.descKey)}</p>
          </button>
        ))}
      </div>
    </div>
  )
}
